import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StaffPageShell from '../components/StaffPageShell';
import VeOnboardingForm from '../components/VeOnboardingForm';
import usePermissions from '../hooks/usePermissions';
import useVeOnboardingForm from '../hooks/useVeOnboardingForm';
import { ThemeButton } from '../components/ThemeWrapper';

function canSubmitOnboarding(hasPermission) {
  return hasPermission('users.add') || hasPermission('users.requests.review');
}

export default function AdminVeOnboardingPage() {
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();
  const form = useVeOnboardingForm();
  const allowed = canSubmitOnboarding(hasPermission);

  useEffect(() => {
    if (!allowed) navigate('/dashboard');
  }, [allowed, navigate]);

  if (!allowed) return null;

  return (
    <StaffPageShell
      title="VLSI EXPERT Onboarding Form"
      subtitle="Staff onboarding. Students only send name, email, phone, and objective from Request access."
      wide
      backTo={hasPermission('users.requests.review') ? '/admin/creation-requests' : '/dashboard'}
      backLabel={hasPermission('users.requests.review') ? 'Account requests' : 'Dashboard'}
      actions={
        hasPermission('users.requests.review') ? (
          <ThemeButton type="button" variant="outline" onClick={() => navigate('/admin/creation-requests')}>
            Open queue
          </ThemeButton>
        ) : null
      }
    >
      <div className="theme-card rounded-lg p-4 md:p-6">
        <VeOnboardingForm {...form} />
      </div>
    </StaffPageShell>
  );
}
